import { render, staticRenderFns } from "./ReleaseNoteCard.vue?vue&type=template&id=1b3168f6&scoped=true&"
import script from "./ReleaseNoteCard.vue?vue&type=script&lang=ts&"
export * from "./ReleaseNoteCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseNoteCard.vue?vue&type=style&index=0&id=1b3168f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3168f6",
  null
  
)

export default component.exports